import Vue from 'vue';
import { getTdProduct } from '@/api/system';

export default Vue.extend({
    data() {
        return {
            value: ''
        };
    },
    created() {
        this.value = this.params.value;
    },
    mounted() {
        Vue.nextTick(() => {
            // need to check if the input reference is still valid - if the edit was cancelled before it started there
            // wont be an editor component anymore
            if (this.$refs.input) {
                this.$refs.input.focus();
                if (this.params.keyPress === 46) {
                    this.value = null;
                } else if (this.params.charPress === null) {
                    this.value = this.params.value;
                } else if (this.value === null) {
                    this.value = this.params.charPress;
                } else {
                    this.value = this.value ?
                        Number(this.value.toString() + this.params.charPress) :
                        this.params.charPress;
                }
            }
        });
    },
    methods: {
        querySearchAsync(queryString, cb) {
            if (this.value.length >= 5) {
                getTdProduct('ph', this.params.data.category, this.value).then(
                    res => {
                        const data = [];

                        res.data.data.forEach(element => {
                            data.push({ value: element.category });
                        });
                        cb(data);
                    }
                );
            }
        },
        handleSelect(item) {
            this.value = item.value.substring(0, 8);
        },
        onChange() {
            this.value = this.value.replace(/[^0-9]/gi, '');
        },
        getValue() {
            return this.value;
        }
    },
    template: `
        <el-autocomplete
            v-model="value"
            :trigger-on-focus="false"
            :fetch-suggestions="querySearchAsync"
            @keyup.native="onChange"
            @select="handleSelect"
            :ref="'input'"
            style="width: 100%"
        ></el-autocomplete>
    `
});



// WEBPACK FOOTER //
// ./src/views/my/planTemplate/components/gcas.js